import {
  CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CSS_CDN_BEGIN,
  CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CSS_CDN_SUCCESS,
  CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CSS_CDN_FAILURE,
  CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CSS_CDN_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function updateCustomComponentCssCdn(args = {}) {
  return (dispatch) => {
    dispatch({
      type: CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CSS_CDN_BEGIN,
    });

    const { projectId, version, componentId, cdnId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/custom-component/${componentId}/CssCdn/${cdnId}`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CSS_CDN_SUCCESS,
              data: res.data,
            });
            toast.success('Updated Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CSS_CDN_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CSS_CDN_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateCustomComponentCssCdnError() {
  return {
    type: CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CSS_CDN_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CSS_CDN_BEGIN:
      return {
        ...state,
        updateCustomComponentCssCdnPending: true,
        updateCustomComponentCssCdnError: null,
      };

    case CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CSS_CDN_SUCCESS:
      const customComponents = state.customComponents;
      const index = customComponents.findIndex((comp) => comp.uuid === action.data.uuid);
      customComponents[index] = action.data;
      return {
        ...state,
        updateCustomComponentCssCdnPending: false,
        updateCustomComponentCssCdnError: null,
        customComponents,
        currentCustomComponent: action.data,
      };

    case CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CSS_CDN_FAILURE:
      return {
        ...state,
        updateCustomComponentCssCdnPending: false,
        updateCustomComponentCssCdnError: action.data.error,
      };

    case CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CSS_CDN_DISMISS_ERROR:
      return {
        ...state,
        updateCustomComponentCssCdnError: null,
      };

    default:
      return state;
  }
}
